module.exports = __webpack_public_path__ + "static/benefits-7562d167b36b54d89895164822f78cde.png";